import React from 'react';
import { Route, Redirect } from 'react-router';

export const PrivateRoute = ({ component: Component, ...res }) => {
	let isAuth = false;
	if (typeof res.location.state !== 'undefined') {
		isAuth = res.location.state.isAuth;
	}


	return (
		<Route render={
			props => res.isAuth === true || isAuth ? (<Component {...props} />) :
				(<Redirect to={{ pathname: "/login" }} />)
		}
		/>
	);
};
